import delay from 'delay'

const createAnnouncements = ({
  allAnnouncementsAtom,
  shownAnnouncementsAtom,
  shownForcedAnnouncementsAtom,
  fetch,
  logger,
  config,
}) => {
  const { apiUrl, maxRetries, retryDelay } = config

  const load = async () => {
    let attempts = 0

    while (attempts <= maxRetries) {
      try {
        const resp = await fetch(apiUrl, { headers: { Accept: 'application/json' } })

        if (resp.status < 200 || resp.status >= 300) {
          throw new Error(`Recieved status: ${resp.status}`)
        } else {
          const data = await resp.json()

          await allAnnouncementsAtom.set(data)
          return
        }
      } catch (error) {
        logger.error('Failed to fetch announcements.', error.message)
        attempts++

        if (attempts <= maxRetries) {
          await delay(retryDelay)
        }
      }
    }

    logger.error('Failed to fetch announcements after maximum attempts.')
  }

  const dispose = async (id) => {
    const announcements = await allAnnouncementsAtom.get()
    const announce = announcements.find((v) => v.id === id)
    if (!announce) {
      return
    }

    if (announce.forceShowOnAppStart) {
      await shownForcedAnnouncementsAtom.set((oldValue) => ({ ...oldValue, [id]: true }))
    } else {
      await shownAnnouncementsAtom.set((oldValue) => ({ ...oldValue, [id]: true }))
    }
  }

  return { load, dispose }
}

const announcementsDefinition = {
  id: 'announcements',
  type: 'module',
  factory: createAnnouncements,
  dependencies: [
    'allAnnouncementsAtom',
    'shownAnnouncementsAtom',
    'shownForcedAnnouncementsAtom',
    'fetch',
    'logger',
    'config',
  ],
  public: true,
}

export default announcementsDefinition
